export default value =>
  value
    .replace(/(-|_|\.|\s)+(.)?/g, (match, separator, chr) => (chr ? chr.toUpperCase() : ''))
    .replace(/(^|\/)([A-Z])/g, match => match.toLowerCase());
